import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Scale, Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0F17] px-4">
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "28px 28px" }} />
      <div className="relative w-full max-w-sm rounded-2xl border border-white/10 bg-[#111723] p-8 shadow-2xl fade-up">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-600/15 ring-1 ring-blue-500/30">
            <Scale className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-bold text-slate-50">Dicta</h1>
            <p className="font-mono-data text-[11px] text-slate-500">Secure team access</p>
          </div>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-xs text-slate-400">Email</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@firm.com"
              className="mt-1 border-white/10 bg-[#0B0F17] text-sm text-slate-100"
              required
            />
          </div>
          <div>
            <Label className="text-xs text-slate-400">Password</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1 border-white/10 bg-[#0B0F17] text-sm text-slate-100"
              required
            />
          </div>
          {error && (
            <p data-testid="login-error" className="rounded-md bg-red-500/10 px-3 py-2 text-xs text-red-400">{error}</p>
          )}
          <Button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white hover:bg-blue-700"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="mr-2 h-4 w-4" /> Sign In</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
